module.exports = __webpack_public_path__ + "static/media/ic_check.ada58f44.svg";